import React, { useEffect, useRef } from 'react';
import { FaSearch } from "react-icons/fa";
import {useNavigate} from 'react-router-dom';
import './SearchFrom.css';
import { useGlobalContext } from '../../context';

const SearchFrom = () => {
  const {setSearchTerm,setResultTitle} = useGlobalContext();
  const searchText = useRef('');
  const navigate = useNavigate();

  useEffect(()=>searchText.current.focus(),[]);

  const handleSubmit = (e) =>{
    e.preventDefault();
    let tempSearchTerm = searchText.current.value.trim();
    if((tempSearchTerm.replace(/[^\w\s]/gi,"")).length === 0){
      setSearchTerm("the lost world");
      setResultTitle("Please Enter Something...");
    }else{
      setSearchTerm(searchText.current.value);
    }
    navigate("/book")
  }

  return (
    <div className='search-form'>
      <div className="container">
        <div className="search-form-content">
          <form className="search-form" onSubmit={handleSubmit}>
            <div className="search-form-elem flex flex-sb bg-white">
              <input type='text' className='form-control' placeholder='React Books' ref={searchText}/>
              <button type='submit' className='flex flex-c' onClick={handleSubmit}>
              <FaSearch size={35} className='text-purple'/>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SearchFrom